// src/config/brand.js
export const brandConfig = {
    companyName: process.env.REACT_APP_COMPANY_NAME || 'My App',
    documentationUrl: process.env.REACT_APP_DOCUMENTATION_URL || '#',
    apiUrl: process.env.REACT_APP_API_BASE_URL || '',

    primaryColor: process.env.REACT_APP_COMPANY_COLOR || '#1d1d1f',
    accentColor: process.env.REACT_APP_COMPANY_ACCENT_COLOR || '#0071e3',

    backgroundTop: process.env.REACT_APP_COMPANY_BG_TOP || '#f5f5f7',
    backgroundBottom: process.env.REACT_APP_COMPANY_BG_BOTTOM || '#ffffff',

    logo: process.env.REACT_APP_COMPANY_LOGO || null
};
